<template>
  <div class="row">
    <div class="col-md-8">
      <edit-profile-form :model="admin"/>
    </div>
    <div class="col-md-4">
      <user-card :user="admin"/>
    </div>
  </div>
</template>
<script>
import EditProfileForm from './Profile/EditProfileForm'
import UserCard from './Profile/UserCard'
import { mapState } from 'vuex'

export default {
  components: {
    EditProfileForm,
    UserCard
  },
  computed: {
    ...mapState(['user']),
    admin: function () {
      if (!this.user || Object.keys(this.user).length === 0) {
        return {
          business_name: '',
          contact_name: '',
          contact_email: '',
          logo_url: '',
          website: '',
          facebook: '',
          twitter: '',
          instagram: '',
          address: '',
          city: '',
          country: '',
          zipcode: '',
          description: ''
        }
      }
      // return this.user.city_admin;
      return this.user.city_admin.city
    }
  }
}
</script>
<style>
</style>
